/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/consistent-indexed-object-style */
export type paths = {
    readonly '/api/healthz': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Meta endpoint that returns 200 if server is ready */
        readonly get: operations['healthz']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/resources/runners/+': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        readonly post?: never
        /** Delete specific resource runner */
        readonly delete: operations['deleteResourcesRunner']
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/resources/schemas': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all of the resource schemas */
        readonly get: operations['getResourceSchemas']
        readonly put?: never
        /** Store resources schemas */
        readonly post: operations['postResourceSchemas']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Read all services */
        readonly get: operations['getServicesV1']
        readonly put?: never
        /** Create a new service */
        readonly post: operations['createService']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/+': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get a specific service */
        readonly get: operations['getServiceV1']
        /** Update an existing service */
        readonly put: operations['updateServiceV1']
        readonly post?: never
        /** Delete an existing service */
        readonly delete: operations['deleteService']
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/+/deletion-status': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Return the remaining time in milliseconds until the service can be installed */
        readonly get: operations['getServiceDeletionStatusV1']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/+/dependencies': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get the service dependencies */
        readonly get: operations['getServiceDependencies']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/+/operation': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        /** Perform an operation on a service */
        readonly put: operations['execute']
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/+/status': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/all-links': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all links by all services */
        readonly get: operations['getAllLinks']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/info': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/ingress-routes': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all ingress routes */
        readonly get: operations['getIngressRoutes']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/instances': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/links': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all Cybus::Link routes */
        readonly get: operations['getLinks']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/parametersSchema': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Get the service schemas */
        readonly post: operations['getServiceSchemas']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/services/status': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/resources': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Read all resources */
        readonly get: operations['getResources']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/resources/+': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Read a specific resource */
        readonly get: operations['getResource']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/resources/+/operation': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        /** Update an existing resources */
        readonly put: operations['updateResourceState']
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/resources/count/+': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get count of resources by category */
        readonly get: operations['getResourceCategoryCount']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/service-graph/adjacency-matrix': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get adjacency matrix of services */
        readonly get: operations['getAdjacencyMatrix']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/service-graph/dependencies': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all dependencies of a list of services */
        readonly get: operations['getAllDependencies']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/service-graph/dependencies/count': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get number of dependencies of a service */
        readonly get: operations['getNumberOfDependencies']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/service-graph/dependents': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all dependents of a list services */
        readonly get: operations['getAllDependents']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/service-graph/dependents/count': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get number of dependents of a service */
        readonly get: operations['getNumberOfDependents']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/service-graph/root-nodes': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all root nodes, i.e. all nodes which have no dependencies */
        readonly get: operations['getRootNodes']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/services': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Read all services */
        readonly get: operations['getServices']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/services/+': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get a specific service */
        readonly get: operations['getService']
        /** Update an existing service */
        readonly put: operations['updateService']
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/services/+/resources': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Read resources by for service */
        readonly get: operations['getResourcesByService']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/services/+/serviceCommissioningFile': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get ServiceCommissioningFile for specific service */
        readonly get: operations['getServiceCommissioningFile']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/services/+/topics': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get available topics for service ID */
        readonly get: operations['getTopicsForServiceId']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/services/ids': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get paginated list of service IDs for all Services order lexicographically Ascending */
        readonly get: operations['getServiceIDs']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/services/stats/count': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get the number of installed Services */
        readonly get: operations['getServiceCounts']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/topics/resources': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get available topics for resources */
        readonly get: operations['getTopics']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/validate/service': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** validate a commissioning file */
        readonly post: operations['validateCommissioningFile']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
}
export type components = {
    schemas: {
        readonly AdjecencyMatrix: {
            readonly dependencies: readonly components['schemas']['ServiceDependency'][]
        }
        readonly AdsConnectionResource: {
            /** @enum {string} */
            readonly category?: 'Connection'
            /** @enum {string} */
            readonly protocol?: 'ads'
            readonly resourceConfig?: {
                readonly args?: {
                    readonly connection: {
                        readonly host: string
                        readonly localPort: number
                        readonly port: number
                        readonly routerTcpPort?: number
                    }
                }
            }
        }
        /** @description Keys must match the pattern `[a-zA-Z0-9]+`. */
        readonly AllSchemas: {
            readonly [key: string]: Record<string, never>
        }
        readonly BacnetConnectionResource: {
            /** @enum {string} */
            readonly category?: 'Connection'
            /** @enum {string} */
            readonly protocol?: 'bacnet'
            readonly resourceConfig?: {
                readonly args?: {
                    readonly connection: {
                        readonly deviceAddress: string
                        readonly deviceInstance: number
                    }
                }
            }
        }
        readonly EndpointResource: {
            /** @enum {string} */
            readonly category?: 'Endpoint'
            readonly protocol?: string
            readonly resourceConfig?: {
                readonly args?: {
                    readonly address: {
                        readonly [key: string]: unknown
                    }
                    /** @enum {string} */
                    readonly operation: 'read' | 'subscribe' | 'write'
                    readonly rules?: readonly {
                        readonly [key: string]: unknown
                    }[]
                    readonly topic: string
                }
            }
        }
        readonly HeidenhainConnectionResource: {
            /** @enum {string} */
            readonly category?: 'Connection'
            /** @enum {string} */
            readonly protocol?: 'heidenhain'
            readonly resourceConfig?: {
                readonly args?: {
                    readonly connection: {
                        /** @enum {string} */
                        readonly cncType: 'tnc640' | 'itnc530' | 'tnc426'
                        readonly ipAddress: string
                    }
                }
            }
        }
        readonly IngressRoute: {
            readonly containerHost?: string
            readonly containerPort?: number
            readonly containerPrefixRewrite?: string
            readonly headers?: readonly string[]
            readonly id?: string
            readonly ingressPort?: number
            readonly ingressUrlPrefix?: string
            readonly type?: string
        }
        /**
         * @description Number of items per page
         * @default 50
         */
        readonly itemsPerPage: number
        readonly JSONAPI: {
            readonly version: components['schemas']['JSONAPIVersion']
        }
        readonly JSONAPIError: {
            readonly errors: readonly {
                /** @example This endpoint has been deprecated and is no longer available. */
                readonly detail: string
                /** @example 410 */
                readonly status: string
                /** @example Gone */
                readonly title: string
            }[]
            readonly jsonapi: components['schemas']['JSONAPI']
        }
        readonly JSONAPIParserError: {
            readonly errors: [
                {
                    /** @example Error in commissioning file */
                    readonly detail: string
                    readonly parserErrors: [components['schemas']['ParserError'], ...components['schemas']['ParserError'][]]
                    /** @example 406 */
                    readonly status: string
                    /** @example Validation failed */
                    readonly title: string
                },
                ...{
                    /** @example Error in commissioning file */
                    readonly detail: string
                    readonly parserErrors: [components['schemas']['ParserError'], ...components['schemas']['ParserError'][]]
                    /** @example 406 */
                    readonly status: string
                    /** @example Validation failed */
                    readonly title: string
                }[]
            ]
            readonly jsonapi: components['schemas']['JSONAPI']
        }
        readonly JsonApiResourceCountPerCategoryEnvelope: {
            readonly data: {
                /** @example 1000 */
                readonly resourceCount: number
            }
            readonly jsonapi: components['schemas']['JSONAPI']
            /** @example {} */
            readonly meta: Record<string, never>
        }
        readonly JsonApiResourceEnvelope: {
            readonly data: components['schemas']['Resource']
            readonly jsonapi: components['schemas']['JSONAPI']
            /** @example {} */
            readonly meta: Record<string, never>
        }
        readonly JsonApiResourceListEnvelope: {
            readonly data: readonly components['schemas']['Resource'][]
            readonly jsonapi: {
                /** @example 1.1 */
                readonly version: string
            }
            readonly meta: {
                readonly pagination: components['schemas']['pagination']
            }
        }
        readonly JsonApiServiceCommissioningFile: {
            readonly parameters_schema: {
                readonly [key: string]: unknown
            }
            readonly scf: string
        }
        readonly JsonApiServiceCommissioningFileEnvelope: {
            readonly data: components['schemas']['JsonApiServiceCommissioningFile']
            readonly jsonapi: components['schemas']['JSONAPI']
            /** @example {} */
            readonly meta: Record<string, never>
        }
        readonly JsonApiServiceDetailsEnvelope: {
            readonly data: components['schemas']['ServiceDetails']
            readonly jsonapi: components['schemas']['JSONAPI']
            /** @example {} */
            readonly meta: Record<string, never>
        }
        readonly JsonApiServiceIds: {
            readonly data: readonly string[]
            readonly jsonapi: components['schemas']['JSONAPI']
            readonly meta: {
                readonly pagination: components['schemas']['pagination']
            }
        }
        readonly JsonApiServiceListEnvelope: {
            readonly data: readonly components['schemas']['Service'][]
            readonly jsonapi: components['schemas']['JSONAPI']
            readonly meta: {
                readonly pagination: components['schemas']['pagination']
            }
        }
        readonly JsonApiServiceUpdateEnvelope: {
            readonly jsonapi: components['schemas']['JSONAPI']
            /** @example {} */
            readonly meta: Record<string, never>
        }
        readonly JsonApiStatsServicesCountEnvelope: {
            readonly data: {
                /** @example 1000 */
                readonly servicesCount: number
            }
            readonly jsonapi: components['schemas']['JSONAPI']
            /** @example {} */
            readonly meta: Record<string, never>
        }
        readonly JsonApiTopicListEnvelope: {
            readonly data: readonly components['schemas']['ResourceTopic'][]
            readonly jsonapi: {
                /** @example 1.1 */
                readonly version: string
            }
            readonly meta: {
                readonly pagination: components['schemas']['pagination']
            }
        }
        /** @example 1.1.1 */
        readonly JSONAPIVersion: string
        readonly KafkaConnectionResource: {
            /** @enum {string} */
            readonly category?: 'Connection'
            /** @enum {string} */
            readonly protocol?: 'kafka'
            readonly resourceConfig?: {
                readonly args?: {
                    readonly connection: {
                        readonly brokers: readonly string[]
                    }
                }
            }
        }
        readonly Link: {
            readonly href?: string
            readonly id?: string
            readonly ingressRoute?: string
            readonly name?: string
        }
        readonly LinkedService: {
            readonly id: string
            readonly links: readonly {
                readonly href: string
                readonly name: string
            }[]
            readonly name: string
        }
        readonly MappingResource: {
            /** @enum {string} */
            readonly category?: 'Mapping'
            readonly protocol?: string
            readonly resourceConfig?: {
                readonly args?: {
                    readonly mappings: readonly {
                        readonly publish: components['schemas']['MappingResourceConfigPubSub']
                        readonly rules?: readonly {
                            readonly [key: string]: unknown
                        }[]
                        readonly subscribe: readonly components['schemas']['MappingResourceConfigPubSub'][]
                    }[]
                }
            }
        }
        readonly MappingResourceConfigPubSub: {
            readonly connection?: string
            readonly endpoint?: string
            readonly topic: string
        }
        readonly MarketplaceServiceRequest: {
            readonly directory?: string
            readonly filename?: string
            /** Format: date-time */
            readonly updatedAt?: string
            readonly version?: string
        }
        /** @description A list of services from the service graph */
        readonly NodeList: {
            /** @description List of nodes */
            readonly nodes: readonly string[]
        }
        readonly NodeResource: {
            /** @enum {string} */
            readonly category?: 'Node'
            readonly parentResourceId?: string
            readonly protocol?: string
            readonly resourceConfig?: {
                readonly args?: {
                    /** @enum {string|null} */
                    readonly operation: 'serverProvides' | 'serverReceives' | 'serverProvidesAndReceives' | 'transaction' | null
                    readonly topic: string
                }
            }
        }
        readonly OtherConnectionsResource: {
            /** @enum {string} */
            readonly category?: 'Connection'
            readonly protocol?: string
            readonly resourceConfig?: {
                readonly args?: {
                    readonly connection: {
                        readonly [key: string]: unknown
                    }
                }
            }
        }
        readonly OtherResources: {
            /** @enum {string} */
            readonly category?: 'Container' | 'File' | 'IngressRoute' | 'Link' | 'Role' | 'User' | 'Volume'
        }
        /**
         * @description A page number
         * @default 1
         */
        readonly pageNumber: number
        readonly pagination: {
            readonly nextPage: components['schemas']['pageNumber']
            readonly pageNumber: components['schemas']['pageNumber']
            readonly rowsPerPage: components['schemas']['itemsPerPage']
            readonly totalPages: components['schemas']['pageNumber']
            /** @example 1 */
            readonly totalRows: number
            /** @example 1 */
            readonly totalRowsInPage: number
        }
        readonly ParserError: {
            readonly dataPath?: string
            readonly keyword?: string
            readonly message: string
            /** @description Can either be a string or an object with:
             *       - additionalProperty: string
             *       - allowedValues: array of strings
             *      */
            readonly params?: {
                readonly [key: string]: unknown
            }
        }
        readonly Resource: {
            /** @example Endpoint */
            readonly category: string
            /** @example myOtherService-myConnectionResource */
            readonly parentResourceId: string | null
            /** @example Http */
            readonly protocol: string | null
            /** @example {
             *       "args": {
             *         "targetState": "enabled",
             *         "subscribe": {
             *           "path": "/sayHello",
             *           "method": "POST"
             *         }
             *       }
             *     } */
            readonly resourceConfig: {
                readonly args: {
                    readonly [key: string]: unknown
                }
            }
            /** @example myResource */
            readonly resourceId: string
            /** @example protocol-mapper */
            readonly runnerName: string
            /** @example myService */
            readonly serviceId: string
        } & (
            | components['schemas']['NodeResource']
            | components['schemas']['ServerResource']
            | components['schemas']['MappingResource']
            | components['schemas']['EndpointResource']
            | components['schemas']['AdsConnectionResource']
            | components['schemas']['BacnetConnectionResource']
            | components['schemas']['HeidenhainConnectionResource']
            | components['schemas']['KafkaConnectionResource']
            | components['schemas']['OtherConnectionsResource']
            | components['schemas']['OtherResources']
        )
        readonly ResourceOperationRequest: {
            /**
             * @description Disable and enable
             * @enum {string}
             */
            readonly operation: 'disable' | 'enable'
        }
        readonly ResourcePostSchemasRequest: {
            /** @description List of resources schemas */
            readonly schemas: [Record<string, never>, ...Record<string, never>[]]
        }
        readonly ResourcesRunner: {
            /** @description The id of the deleted resource runner */
            readonly id?: string
        }
        readonly ResourceTopic: {
            /**
             * @example Endpoint
             * @enum {string}
             */
            readonly category: 'Endpoint' | 'Node' | 'Mapping'
            /** @example servicea-A_000 */
            readonly resourceId: string
            /** @example servicea */
            readonly serviceId: string
            /** @example services/servicea/A/000 */
            readonly topic: string
        }
        readonly ServerResource: {
            /** @enum {string} */
            readonly category?: 'Server'
            readonly protocol?: string
        }
        readonly Service: {
            /** @example 2025-03-06T22:13:43.065Z */
            readonly createdAt: string
            /** @example disabled */
            readonly currentState: string
            /** @example My Service */
            readonly name: string
            /** @example myService */
            readonly serviceId: string
            /** @example enabled */
            readonly targetState: string
            /** @example 2025-03-06T22:13:43.065Z */
            readonly updatedAt: string
            /** @example v1.2.3 */
            readonly version: string
        }
        readonly ServiceDependencies: {
            /** @description Ids of dependent cross reference services */
            readonly dependent: readonly string[]
            /** @description Ids of depends on cross reference services */
            readonly dependsOn: readonly string[]
        }
        readonly ServiceDependency: {
            /** @description The ID of the node that depends on 'toNode' */
            readonly fromNode: string
            /** @description The ID of the node that 'fromNode' depends on */
            readonly toNode: string
        }
        readonly ServiceDetails: {
            /** @example 10 */
            readonly connectionCount: number
            /** @example 81a6c550-fad5-11ef-a38c-0242ac120006 */
            readonly connectwareServiceUuid: string
            /** @example 5 */
            readonly containerCount: number
            /** @example 2025-03-06T22:13:43.065Z */
            readonly createdAt: string
            /** @example disabled */
            readonly currentState: string
            /** @example My Service has some resources */
            readonly description: string
            /** @example 11 */
            readonly endpointCount: number
            /** @example 4 */
            readonly fileCount: number
            /** @example cybus.io */
            readonly homepage: string | null
            /** @example TGFyYTwz */
            readonly icon: string | null
            /** @example 6 */
            readonly ingressRouteCount: number
            /** @example 7 */
            readonly linkCount: number
            /** @example 12 */
            readonly mappingCount: number
            readonly marketPlace: {
                readonly directory?: string
                readonly filename?: string
                readonly updatedAt?: string
                readonly version?: string
            }
            /** @example My Service */
            readonly name: string
            /** @example 8 */
            readonly nodeCount: number
            /** @example {
             *       "host": "cybus.io",
             *       "port": 443
             *     } */
            readonly parameters: Record<string, never>
            /** @example Cybus */
            readonly provider: string | null
            /** @example 1 */
            readonly roleCount: number
            /** @example 9 */
            readonly serverCount: number
            /** @example myService */
            readonly serviceId: string
            /** @example enabled */
            readonly targetState: string
            /** @example 105 */
            readonly totalResources: number
            /** @example 2025-03-06T22:13:43.065Z */
            readonly updatedAt: string
            /** @example 2 */
            readonly userCount: number
            /** @example v1.2.3 */
            readonly version: string
            /** @example 3 */
            readonly volumeCount: number
        }
        readonly ServiceOperationRequest: {
            /**
             * @description Disable and enable
             * @enum {string}
             */
            readonly operation: 'disable' | 'enable' | 'cancel'
        }
        readonly ServicePostRequest: {
            /** @description The commissioning file of this service as base64 encoded content of a buffer */
            readonly commissioningFile: string
            readonly id: string
            readonly marketplace?: components['schemas']['MarketplaceServiceRequest']
            /** @description The parameter values of this service as a JSON object */
            readonly parameters?: {
                readonly [key: string]: unknown
            }
            /** @enum {string} */
            readonly targetState?: 'disabled' | 'enabled'
        }
        readonly ServicePostResult: {
            readonly id: string
        }
        readonly ServicePostSchemasRequest: {
            /** @description The commissioning file of this service as base64 encoded content of a buffer */
            readonly commissioningFile: string
        }
        readonly ServiceSchemas: Record<string, never>
        readonly ServiceStatus: {
            /** @description Current state of the service. */
            readonly currentState?: string
            /** @description Unique identifier representing a specific service. */
            readonly id?: string
            /** @description Target state of the service (user's wish). */
            readonly targetState?: string
        }
        readonly UpdateServiceRequest: {
            readonly commissioningFile?: string
            readonly marketplace?: components['schemas']['MarketplaceServiceRequest']
            readonly parameters?: {
                readonly [key: string]: unknown
            }
        }
        readonly ValidatePostServiceRequest: {
            /** @description The commissioning file of this service as base64 encoded content of a buffer */
            readonly commissioningFile: string
        }
        readonly ValidationError: {
            readonly message: string
        }
    }
    responses: never
    parameters: never
    requestBodies: never
    headers: never
    pathItems: never
}

interface operations {
    readonly healthz: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly deleteResourcesRunner: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of resource runner */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ResourcesRunner']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getResourceSchemas: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Resource schemas in a JSON string */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['AllSchemas']
                }
            }
            /** @description Internal error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly postResourceSchemas: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Add resources schemas */
                readonly 'application/json': components['schemas']['ResourcePostSchemasRequest']
            }
        }
        readonly responses: {
            /** @description Resource schemas stored */
            readonly 201: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getServicesV1: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Permanent Redirect */
            readonly 301: {
                headers: {
                    /** @description The new endpoint URL */
                    readonly Location?: unknown
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly createService: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Service to be created */
                readonly 'application/json': components['schemas']['ServicePostRequest']
            }
        }
        readonly responses: {
            /** @description Created service */
            readonly 201: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ServicePostResult']
                }
            }
            /** @description Validation Error */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['ValidationError'][]
                }
            }
            /** @description Invalid Content */
            readonly 406: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        /** @enum {string} */
                        readonly code: 'InvalidContent'
                        /** @example Error in commissioning file: ParserError[] */
                        readonly message: string
                    }
                }
            }
            /** @description Conflict with service current state */
            readonly 409: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        /** @enum {string} */
                        readonly code: 'Conflict'
                        /** @example Service 'servicea1' is still being removed from the system. Try again in X ms */
                        readonly message: string
                    }
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getServiceV1: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Permanent Redirect */
            readonly 301: {
                headers: {
                    /** @description The new endpoint URL */
                    readonly Location?: unknown
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly updateServiceV1: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Permanent Redirect */
            readonly 308: {
                headers: {
                    /** @description The new endpoint URL */
                    readonly Location?: unknown
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly deleteService: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of service */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        /** @description The id of the deleted service */
                        readonly id: string
                    }
                }
            }
            /** @description Service not found */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly code: string
                        /** @example Service with id 'SERVICE_ID' doesn't exist */
                        readonly message: string
                    }
                }
            }
        }
    }
    readonly getServiceDeletionStatusV1: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of the service */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        /** @description Indicates if service was completely removed and can be installed again */
                        readonly deletionIsComplete: boolean
                        /** @description Ms until service is completely removed. 0 if it's already removed */
                        readonly remainingTimeInMs: number
                        /** @description Id of the service */
                        readonly serviceID: string
                    }
                }
            }
            /** @description Internal Error while fetching service deletion status */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly code: string
                        /** @example GET /api/services/:id/deletion-status ERROR (service 'serviceA'): Something went wrong */
                        readonly message: string
                    }
                }
            }
        }
    }
    readonly getServiceDependencies: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of service */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Service dependencies */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ServiceDependencies']
                }
            }
            /** @description Service not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly execute: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of service */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Operation to perform */
                readonly 'application/json': components['schemas']['ServiceOperationRequest']
            }
        }
        readonly responses: {
            /** @description Service */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['Service']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Service not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getAllLinks: {
        readonly parameters: {
            readonly query?: {
                /** @description Only list on the response resources from enabled services */
                readonly onlyFromEnabledServices?: boolean
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Links */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['LinkedService'][]
                }
            }
        }
    }
    readonly getIngressRoutes: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Ingress routes */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['IngressRoute'][]
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getLinks: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Links */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['Link'][]
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getServiceSchemas: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Get the service parameters schemas */
                readonly 'application/json': components['schemas']['ServicePostSchemasRequest']
            }
        }
        readonly responses: {
            /** @description Service schemas */
            readonly 201: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ServiceSchemas']
                }
            }
            /** @description Validation Error */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['ValidationError'][]
                }
            }
            /** @description Invalid Content */
            readonly 406: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ValidationError']
                }
            }
        }
    }
    readonly getResources: {
        readonly parameters: {
            readonly query?: {
                /** @description Resource categories (multiple allowed) */
                readonly categories?: readonly (
                    | 'Connection'
                    | 'Container'
                    | 'Endpoint'
                    | 'File'
                    | 'IngressRoute'
                    | 'Link'
                    | 'Mapping'
                    | 'Node'
                    | 'Role'
                    | 'Server'
                    | 'User'
                    | 'Volume'
                )[]
                /** @description Number of items per page */
                readonly itemsPerPage?: number
                /** @description Only list on the response resources from enabled services */
                readonly onlyFromEnabledServices?: boolean
                /** @description Ascending or descending order */
                readonly order?: 'ASC' | 'DESC'
                /** @description Order response by field */
                readonly orderBy?:
                    | 'resourceId'
                    | 'runnerName'
                    | 'protocol'
                    | 'parentResourceId'
                    | 'category'
                    | 'connectwareServiceUuid'
                    | 'resourceName'
                    | 'serviceId'
                /** @description Page to return */
                readonly page?: number
                /** @description Filter by parent of requested resources */
                readonly parentResourceId?: string
                /** @description Resource runner name */
                readonly runnerName?: string
                /** @description The value used to retrieve services resources by matching resource name */
                readonly searchText?: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Array of resources */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiResourceListEnvelope']
                }
            }
            /** @description Bad Request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIError']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getResource: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of resource */
                readonly resourceId: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Resource */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiResourceEnvelope']
                }
            }
            /** @description Resource not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly updateResourceState: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of resource */
                readonly resourceId: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Operation to perform on the resource */
                readonly 'application/json': components['schemas']['ResourceOperationRequest']
            }
        }
        readonly responses: {
            /** @description Success */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getResourceCategoryCount: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /**
                 * @description Resource Category
                 * @enum {string}
                 */
                readonly category: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Resource */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiResourceCountPerCategoryEnvelope']
                }
            }
            /** @description Invalid Resource Category provided */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIError']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIError']
                }
            }
        }
    }
    readonly getAdjacencyMatrix: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description List of service relationships */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['AdjecencyMatrix']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getAllDependencies: {
        readonly parameters: {
            readonly query: {
                /** @description Configures how many hops to return, e.g. 1 for direct dependencies only, 2 to return until dependencies of dependencies, etc. */
                readonly distance?: number
                /** @description List of service to get dependencies for */
                readonly serviceIds: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description List of dependencies */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['NodeList']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getNumberOfDependencies: {
        readonly parameters: {
            readonly query: {
                /** @description Configures how many hops to return, e.g. 1 for direct dependencies only, 2 to return until dependencies of dependencies, etc. */
                readonly distance?: number
                /** @description Id of service to get dependencies for */
                readonly serviceId: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Number of dependencies */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getAllDependents: {
        readonly parameters: {
            readonly query: {
                /** @description Configures how many hops to return, e.g. 1 for direct dependents only, 2 to return until dependents of dependents, etc. */
                readonly distance?: number
                /** @description List of services to get dependents for */
                readonly serviceIds: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description List of dependencies */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['NodeList']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getNumberOfDependents: {
        readonly parameters: {
            readonly query: {
                /** @description Configures how many hops to return, e.g. 1 for direct dependents only, 2 to return until dependents of dependents, etc. */
                readonly distance?: number
                /** @description Id of service to get dependents for */
                readonly serviceId: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Number of dependents */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getRootNodes: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description List of root nodes */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['NodeList']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getServices: {
        readonly parameters: {
            readonly query?: {
                /** @description Number of items per page */
                readonly itemsPerPage?: number
                /** @description Ascending or descending order */
                readonly order?: 'ASC' | 'DESC'
                /** @description Order response by field */
                readonly orderBy?: 'serviceId' | 'name' | 'currentState' | 'version' | 'createdAt' | 'targetState' | 'updatedAt'
                /** @description Page to return */
                readonly page?: number
                /** @description The value used to retrieve services by matching service ID or name */
                readonly searchText?: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Array of services */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiServiceListEnvelope']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getService: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of service */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Service */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiServiceDetailsEnvelope']
                }
            }
            /** @description Service not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly updateService: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of service */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Data required for updating a service */
                readonly 'application/json': components['schemas']['UpdateServiceRequest']
            }
        }
        readonly responses: {
            /** @description Accepted */
            readonly 202: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiServiceUpdateEnvelope']
                }
            }
            /** @description Bad Request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIError']
                }
            }
            /** @description Invalid Content */
            readonly 406: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIParserError']
                }
            }
        }
    }
    readonly getResourcesByService: {
        readonly parameters: {
            readonly query?: {
                /** @description Resource categories (multiple allowed) */
                readonly categories?: readonly (
                    | 'Connection'
                    | 'Container'
                    | 'Endpoint'
                    | 'File'
                    | 'IngressRoute'
                    | 'Link'
                    | 'Mapping'
                    | 'Node'
                    | 'Role'
                    | 'Server'
                    | 'User'
                    | 'Volume'
                )[]
                /** @description Number of items per page */
                readonly itemsPerPage?: number
                /** @description Only list on the response resources from enabled services */
                readonly onlyFromEnabledServices?: boolean
                /** @description Ascending or descending order */
                readonly order?: 'ASC' | 'DESC'
                /** @description Order response by field */
                readonly orderBy?:
                    | 'resourceId'
                    | 'runnerName'
                    | 'protocol'
                    | 'parentResourceId'
                    | 'category'
                    | 'connectwareServiceUuid'
                    | 'resourceName'
                    | 'serviceId'
                /** @description Page to return */
                readonly page?: number
                /** @description filter by parentResourceId */
                readonly parentResourceId?: string
                /** @description filter by runner name */
                readonly runnerName?: string
                /** @description The value used to retrieve service resources by matching resource name */
                readonly searchText?: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of service */
                readonly serviceId: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Array of services */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiResourceListEnvelope']
                }
            }
            /** @description Bad Request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIError']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getServiceCommissioningFile: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of service */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description SCF */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiServiceCommissioningFileEnvelope']
                }
            }
            /** @description Bad Request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIError']
                }
            }
            /** @description Service not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIError']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIError']
                }
            }
        }
    }
    readonly getTopicsForServiceId: {
        readonly parameters: {
            readonly query?: {
                /** @description Resource categories (multiple allowed) */
                readonly categories?: readonly ('Endpoint' | 'Mapping' | 'Node')[]
                /** @description Number of items per page */
                readonly itemsPerPage?: number
                /** @description Only list on the response topics from enabled service */
                readonly onlyFromEnabledServices?: boolean
                /** @description Ascending or descending order */
                readonly order?: 'ASC' | 'DESC'
                /** @description Order response by field */
                readonly orderBy?: 'resourceId' | 'category' | 'serviceId'
                /** @description Page to return */
                readonly page?: number
                /** @description The value used to retrieve topics by matching resource name or resource ID */
                readonly searchText?: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of service to list topics for */
                readonly serviceId: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Paginated list of topics */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiTopicListEnvelope']
                }
            }
            /** @description Parameter missing */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description No topics found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getServiceIDs: {
        readonly parameters: {
            readonly query?: {
                /** @description Number of items per page */
                readonly itemsPerPage?: number
                /** @description Page to return */
                readonly page?: number
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Get paginated list of service IDs for all Services order lexicographically Ascending */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiServiceIds']
                }
            }
            /** @description Bad Request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIError']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIError']
                }
            }
        }
    }
    readonly getServiceCounts: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Number of installed Services */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiStatsServicesCountEnvelope']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JSONAPIError']
                }
            }
        }
    }
    readonly getTopics: {
        readonly parameters: {
            readonly query?: {
                /** @description The resource categories to filter by (multiple allowed) */
                readonly categories?: readonly ('Endpoint' | 'Mapping' | 'Node')[]
                /** @description The resource IDs to filter by (multiple allowed) */
                readonly ids?: readonly string[]
                /** @description Number of items per page */
                readonly itemsPerPage?: number
                /** @description Only list on the response topics from enabled services */
                readonly onlyFromEnabledServices?: boolean
                /** @description Ascending or descending order */
                readonly order?: 'ASC' | 'DESC'
                /** @description Order response by field */
                readonly orderBy?: 'resourceId' | 'category' | 'serviceId'
                /** @description Page to return */
                readonly page?: number
                /** @description The value used to retrieve topics by matching resource name or resource ID or service ID */
                readonly searchText?: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Paginated list of topics */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['JsonApiTopicListEnvelope']
                }
            }
            /** @description Parameter missing */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description No topics found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly validateCommissioningFile: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description validate a commissioning file */
                readonly 'application/json': components['schemas']['ValidatePostServiceRequest']
            }
        }
        readonly responses: {
            /** @description Validation Successful */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Validation Error */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['ValidationError'][]
                }
            }
            /** @description Invalid Content */
            readonly 406: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly errors: readonly components['schemas']['ParserError'][]
                        /** @enum {string} */
                        readonly message: 'the provided commissioning file contains errors'
                    }
                }
            }
        }
    }
}

/** An auto-generated constant containing all paths */
export const pathsValue = [
    '/api/healthz' as const,
    '/api/resources/runners/+' as const,
    '/api/resources/schemas' as const,
    '/api/services' as const,
    '/api/services/+' as const,
    '/api/services/+/deletion-status' as const,
    '/api/services/+/dependencies' as const,
    '/api/services/+/operation' as const,
    '/api/services/+/status' as const,
    '/api/services/all-links' as const,
    '/api/services/info' as const,
    '/api/services/ingress-routes' as const,
    '/api/services/instances' as const,
    '/api/services/links' as const,
    '/api/services/parametersSchema' as const,
    '/api/services/status' as const,
    '/api/v2/resources' as const,
    '/api/v2/resources/+' as const,
    '/api/v2/resources/+/operation' as const,
    '/api/v2/resources/count/+' as const,
    '/api/v2/service-graph/adjacency-matrix' as const,
    '/api/v2/service-graph/dependencies' as const,
    '/api/v2/service-graph/dependencies/count' as const,
    '/api/v2/service-graph/dependents' as const,
    '/api/v2/service-graph/dependents/count' as const,
    '/api/v2/service-graph/root-nodes' as const,
    '/api/v2/services' as const,
    '/api/v2/services/+' as const,
    '/api/v2/services/+/resources' as const,
    '/api/v2/services/+/serviceCommissioningFile' as const,
    '/api/v2/services/+/topics' as const,
    '/api/v2/services/ids' as const,
    '/api/v2/services/stats/count' as const,
    '/api/v2/topics/resources' as const,
    '/api/validate/service' as const,
]
